import { createReducer, on } from '@ngrx/store';

import {
    changeSearchTypes,
    searchChangeCategoryPageNum,
} from 'SearchAllApp/state/search-all-params/search-all-params.actions';

import { SearchCategoryPagination } from 'SearchApp/ts/types/search-all-category.type';

export const searchCategoryPageNum = createReducer(
    {},
    on(searchChangeCategoryPageNum, (_: SearchCategoryPagination, action) => {
        return action.searchCategoryPageNum;
    }),
    on(changeSearchTypes, () => {
        return {};
    })
);
